app.ui.registerUi('input', function (app) {

    var helpers = app.helpers.funcs;

	return {
		implementationExists: function() {
			return true; // implementation is entirely encapsulated within this file.
		},
        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },
		init: function ($scope) {

            // Set reference to current scope
		    var scope = this;

            // Get list of DOM-scoped elements
		    var inputSelectorString = [
                'input[type=text]',
                'input[type=password]',
                'input[type=email]',
                'input[type="number"]',
                'input[type="tel"]',
                'textarea'
		    ].join(',');
		    var $inputElems = helpers.resolveScope(inputSelectorString, $scope);

            // Call adjustClass function on load, and in response to listed events.
            $inputElems.on('change focusin keyup', function () {
                scope.adjustClass($(this));
            });
            $inputElems.each(function (k, inputElem) {
                scope.adjustClass($(inputElem));
            });
		},
		adjustClass: function ($inputElem) {
		    var val = $inputElem.val();
		    var c = (val) ? 'filled' : 'empty';
		    $inputElem.removeClass('filled')
                .removeClass('empty')
                .addClass(c);
		}
	};
});
